<template>
    <div class="form-container active" id="step-1" :style="theme">
        <div class="step1">
            <!-- Titre de la page -->
            <h4 class="pres-title">{{this.fo_config['text']['booking_title']}}</h4>
            <!-- Filtre -->
            <template v-for="fConf in this.fo_config['filter']">
              <!-- Agendas -->
              <div class="mb-3" v-if="fConf['targeted_table'] === 'agendas' && display_agendas && filtered_agendas.length >= fConf['min_to_show']">
                  <label for="example1" class="form-label">{{fConf['label']}}</label>
                  <select @change="changeFilters" v-model="agenda_id" class="form-select" aria-label="Default select example">
                      <option  v-if="fConf['nullable']" :value="null">
                          Tous les prestataires ({{filtered_agendas.map((agenda) => agenda.name).slice(0, 5).join(", ")}}, ...)
                      </option>
                      <option v-for="ag in filtered_agendas" :value="ag.agenda_id" :key="ag.agenda_id" >
                          {{ ag.name }}
                      </option>                            
                  </select>
              </div>
              <!-- Lieux -->
              <div class="mb-3" v-else-if="fConf['targeted_table'] === 'locations' && locations.length >= fConf['min_to_show']">
                  <label for="example2" class="form-label">{{fConf['label']}}</label>
                  <select @change="changeFilters" v-model="location_id" class="form-select" aria-label="Default select example">
                      <option v-if="fConf['nullable']" :value="null">Tous les lieux</option>
                      <option :value="location.location_id" v-for="(location, index) in locations" :key="index">
                          {{ location.name }}
                          {{ location.address && fConf['show_address'] == '1' ? `(${renderLocationAddress(location)}, ${location.city})`: "" }}
                      </option>
                  </select>
              </div>
          
              <ul v-else-if="fConf['targeted_table'] === 'categories' && categories && categories.length >= fConf['min_to_show']" class="nav nav-tabs" id="myTab" role="tablist">
                  <li v-for="(categorie, index) in filtered_categories" 
                      v-on:click="onCategoryTagClicked(categorie.category_id)" class="nav-item" role="presentation">
                      <button class="nav-link" id="cat-tab-1" v-bind:class="{active: categorie.category_id == this.store.selected_category}" @click="active_tab = 'cat-tab-1'" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Mes prestations</button>
                  </li>
              </ul>
            </template>
            <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                <div v-if="display_prestations" class="row gapy">
                    <h4 class="title-type-prest">Choisissez une ou plusieurs prestations</h4>
                    <div v-for="(prestation, index) in filtered_prestations" :key="index" class="col-lg-6 col-xl-4">
                        <card-prestation
                                :id="prestation.prestation_id" :title="prestation.fo_name || prestation.bo_name" 
                                :display_duration="config.display_duration && prestation.display_duration" :duration="prestation.duration" 
                                :display_price="config.display_price && prestation.display_price" :price="prestation.price" currency="€"
                                :text="prestation.fo_description || prestation.bo_description"
                                :enable_count_attendees="prestation.is_group && prestation.allow_subgroup" 
                                :min_attendees="1" :max_attendees="prestation.max_nbr_clients"
                                :selected="this.store.selected_prestations.some(p => p.prestation_id === prestation.prestation_id)"
                                :checked="(isActive === index  && selected_prestations?.[0]?.prestation_id === prestation.prestation_id) ||
                                selected_prestations?.[0]?.prestation_id === prestation.prestation_id"
                                @attendees_nbr="setGroupSize($event, prestation)" @selected="toggleIsActive(index, prestation)"
                                >
                        </card-prestation>
                    </div>
                </div>
            </div>
            <!-- Support step -->
            <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                Support content
            </div>
            <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">
                Autres
            </div>
            </div>
        </div>
        <div class="btn-container">
            <button class=" btn-primary1" id="nextBtn" @click="submit()" :disabled="!can_submit" :title="can_submit ? 'Choisir créneau' : 'Veuillez sélectionner une prestation'">Suivant</button>
        </div>
    </div>    
</template>

<script>
import CardPrestation from './CardPrestation.vue';
import { BookingStore } from '../Stores/BookingStore';

export default {
    name: 'SelectPrestation',
    props: ["agendas", "prestations", "locations", 'fo_config', "settingsConfig"],
    remember: ["agenda_id", "location_id", "category_id"],
    components: { CardPrestation },
    emits: ['submit','agendaChanged','located'],

    data() {
        return {
            active_tab: 'cat-tab-1',
            agenda_id: null,
            category_id: null,
            is_categories_sorted: false,
            categories: [],
            location_id: null,
            prestations_to_show: [],
            selected_prestations: [],
            isActive: null,
            store: BookingStore      
        }
    },

    computed: {
      cdn_subdomain() {
        return this.$page.props.cdn_subdomain;
      },
      config() {
        return this.$page.props.config;
      },
      display_agendas() {
        if (this.config.force_fo_agenda_selection) return true;

        if (!this.config.choose_presta_on_calendar) return false;

        return true;
      },
      display_prestations() {
        if (this.config.force_fo_agenda_selection && !this.agenda_id)
          return false;

        return true;
      },
      client_rdvs() {
        return this.$page.props.client_rdvs;
      },
      // TODO prendre le cas du nullables : tous les agendas selectionnés
      filtered_agendas(){
          let res = this.agendas.filter(agenda => agenda.location_id == this.location_id);
          // this.agenda_id = res.length > 0 ? res[0].agenda_id : null;
          return res;
      },
      // TODO prendre le cas du nullables : tous les categories selectionnées
      filtered_categories(){
          // this.category_id = null;
          let prestations = this.display_agendas ? this.prestations.filter(prestation => prestation.agendas.find(agenda => agenda.agenda_id == this.agenda_id)) : this.getPrestaionsByLocation(this.location_id,this.prestations);
          let res = this.categories.filter(category => {
              for (const presta of prestations) {
                  if(presta.categories.find(cat => cat.category_id == category.category_id)) return true;
              }
              return false;
          });
          // Si il n'y a que la catégorie "Sans catégorie" ne pas la retourner
          if(res && res.length < 2) return [];
          return res;
      },
      filtered_prestations(){
          let prestations = [];
          if((this.display_agendas && this.agenda_id) || (!this.display_agendas)){
            let filtered_categories = this.filtered_categories;
            // Si il y a une catégorie sélectionnée ou aucune n'existe
            if(this.category_id || (!this.category_id && filtered_categories.length < 1)){
              prestations = this.prestations.filter(presta => {
                presta.group_size = presta.group_size ?? 0;
                // Si la prestation appartient à l'agenda sélectionné
                
                let has_agenda_id = presta.agendas.find(agenda => agenda.agenda_id == this.agenda_id);
                // Si la prestation appartient à la catégorie sélectionnée
                let has_category_id = filtered_categories.length > 0 ? presta.categories.find(category => category.category_id == this.category_id) : true; // Par défaut appartient à la catégorie si aucune n'existe
                // Sélectionner la prestation si appartient à l'agenda et à la catégorie sélectionnée
                  let res = this.display_agendas && has_category_id && has_agenda_id || !this.display_agendas && has_category_id;
                  return res;
              });
            }
          }
          return prestations;
      },
      theme(){
          return this.fo_config['theme'];
      },
      can_choose_slot(){
        return this.subgroup_in_range;
      },
      subgroup_in_range(){
        if(this.selected_prestations.length != 1 || !this.selected_prestations[0].is_group || !this.selected_prestations[0].allow_subgroup){
          return true;
        }
        let presta = this.selected_prestations[0];
        if(presta.max_nbr_clients < presta.group_size) return false;
        if(presta.allow_min_subgroup && presta.min_nbr_subgroup > presta.group_size) return false;
        if(presta.allow_max_subgroup && presta.max_nbr_subgroup < presta.group_size) return false;
        return true;
      },
      can_submit(){
        return this.selected_prestations.length > 0;
      }
    },

    watch: {
      agenda_id(value){
        console.log('watch agendaid',value);
        this.store.selected_agenda_id = value;
        this.$emit('agendaChanged',this.agendas.find(agenda => agenda.agenda_id == value));
      },
      location_id(value){
        console.log('watch locationid',value);
        this.store.selected_location_id = value;
        this.$emit('located',this.locations.find(location => location.location_id == value));
      },
      store(value) {
        console.log('watch store', value)
      }
    },

    methods: {
      toggleIsActive(index, prestation) {
        if (this.isActive === index) {
          console.log('BookingStore----->', BookingStore.selected_prestations);
          this.isActive = null;
          this.removePrestation(prestation);
        }
        else {
          console.log('BookingStore----->', BookingStore.selected_prestations);
          this.isActive = index;
          this.removeAllPrestation()
          this.addPrestation(prestation);
        }
      },
      addPrestation(prestation) {
        if (this.isSelected(prestation)) return false;
        if (this.config.prestation_groupe_enable && prestation.is_group)
          this.selected_prestations = [];
        if (
          prestation.is_group &&
          prestation.allow_subgroup &&
          !prestation.group_size
        )
          prestation.group_size = 1;
        this.selected_prestations.push(prestation);
      },
      getPrestationImagePath(prestation) {
        let host = window.location.host.split(".");
        if (!host[1]) return false;
        let subdomain = host.shift();
        return (
          window.location.protocol +
          "//" +
          this.cdn_subdomain +
          "." +
          host.join(".") +
          "/datas/" +
          subdomain +
          "/images/prestations/" +
          prestation.image
        );
      },
      isSelectable(prestation) {
        if (this.selected_prestations.length === 0) return true;
        if (!this.config.prestation_combo_enable) return false;
        if (prestation.is_group) return false;
        if (this.selected_prestations[0].is_group) return false;
        return true;
      },
      isSelected(prestation) {
        return this.selected_prestations.find(
          (presta) => prestation.prestation_id == presta.prestation_id
        );
      },
      parseUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("agenda_id") && parseInt(urlParams.get("agenda_id")))
          this.agenda_id = urlParams.get("agenda_id");
        if (
          urlParams.get("location_id") &&
          parseInt(urlParams.get("location_id"))
        )
          this.location_id = urlParams.get("location_id");
        if (
          urlParams.get("category_id") &&
          parseInt(urlParams.get("category_id"))
        )
          this.category_id = urlParams.get("category_id");
      },
      removeAllPrestation() {
        this.selected_prestations = [];
      },
      removePrestation(prestation) {
        this.selected_prestations = this.selected_prestations.filter(
          (presta) => prestation.prestation_id != presta.prestation_id
        );
      },
      renderLocationAddress(location) {
        if (!location.address) return ''
        let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
        return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
      },
      save() {
        if (this.config.force_fo_agenda_selection && !this.agenda_id) {
          return toast({
            message:
              "Le choix du prestataire est obligatoire pour passer à l'étape suivante.",
            type: "is-warning",
            duration: 4000,
            pauseOnHover: true,
          });
        }

        if (this.selected_prestations.length === 0) {
          return toast({
            message: "Merci de choisir au moins une prestation.",
            type: "is-warning",
            duration: 4000,
            pauseOnHover: true,
          });
        }

        let query = {};
        query.prestation_id = this.selected_prestations.map(
          (prestation) => {
              // Calcul du prix
              query.price = 0;
              query.price += prestation.price;
              return prestation.prestation_id
          }
        );
        if (this.location_id) query.location_id = this.location_id;
        if (this.agenda_id) query.agenda_id = this.agenda_id;

        if (this.selected_prestations.find((prestation) => prestation.is_group)) {
          if (this.selected_prestations.length > 1) {
            return toast({
              message:
                "Impossible de combiner les prestations de groupe avec d'autre prestations.",
              type: "is-danger",
              duration: 4000,
              pauseOnHover: true,
            });
          }
          let prestation = this.selected_prestations[0];
          if (!prestation.allow_subgroup) query.group_size = 1;
          else query.group_size = prestation.group_size || 1;
          query.price = prestation.price*query.group_size;
        }
        let query_string = new URLSearchParams(query).toString();
        let route = "/times";
        if (query_string) route += "?" + query_string;
        this.$inertia.get(route);
      },
      setCategories() {
          this.categories = [];
          let categories = this.prestations.map((prestation) => prestation.categories).flat();
          for (let categorie of categories) {
                  if (!this.categories.find((cat) => cat.category_id == categorie.category_id))
                  this.categories.push(categorie);
          }
      },
      setPrestasWithoutCategory(){
          for (let i = 0; i < this.prestations.length; i++) {
              if(this.prestations[i].categories.length === 0){
                  this.prestations[i].categories.push({
                      bo_description: "",
                      bo_name: "",
                      category_id: -1,
                      color: null,
                      enabled: null,
                      fo_description: "",
                      fo_name: "Autres",
                      image: null,
                      pivot: null,
                      position: null
                  })
              }
          }
      },
      setDefaultAgenda() {
        if (this.client_rdvs.length === 0) return null;

        let orderedRdvs = this.client_rdvs.sort(
          (a, b) =>
            new Date(a.start_date).getTime() < new Date(b.start_date).getTime()
        );
        let last_rdv = orderedRdvs[0];
        this.agenda_id = last_rdv.agenda_id;
      },
      setGroupSize(group_size, prestation) {
        // let group_size = e.target.value;
        let selected_prestation = this.selected_prestations.find(
          (p) => p.prestation_id == prestation.prestation_id
        );
        selected_prestation.group_size = group_size;
      },
      setPrestations() {
        let prestations = this.prestations;
        let query = {};
        if (this.agenda_id) {
          prestations = prestations.filter((prestation) =>
            prestation.agendas.find(
              (agenda) => agenda.agenda_id == this.agenda_id
            )
          );
          query.agenda_id = this.agenda_id;
        }
        if (this.location_id) {
          prestations = prestations.filter((prestation) =>
            prestation.agendas.find(
              (agenda) => agenda.location_id == this.location_id
            )
          );
          query.location_id = this.location_id;
        }
        if (this.category_id) {
          prestations = prestations.filter((prestation) =>
            prestation.categories.find(
              (category) => category.category_id == this.category_id
            )
          );
          query.category_id = this.category_id;
        }
        this.prestations_to_show = prestations;
      },

      changeFilters() {
        let query = {};
        if (this.agenda_id) {
          query.agenda_id = this.agenda_id;
          this.store.selected_agenda_id = this.agenda_id;
        }
        if (this.location_id) {
          query.location_id = this.location_id;
          this.store.selected_location_id = this.location_id;
        }
        if (this.category_id) {
          query.category_id = this.category_id;
          this.store.selected_category = this.category_id;
        }
      },
      onCategoryTagClicked(id){
          this.category_id = id;
          // this.store.selected_category = id
          this.changeFilters();
      },

      getPrestaionsByLocation(location_id, prestations){
          let filtered = [];
          for (let presta of prestations) {
              let agenda = presta.agendas.find(item => item.location_id === location_id);
              if(agenda){
                  filtered.push(presta);
              }
          }
          return filtered;
      },
      setBodyStyle(){
          document.body.style.backgroundColor = this.theme['--body-bg-color'];
      },

      submit(){
        if(this.can_submit){
            let agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
            let location = this.locations.find(location => location.location_id == this.location_id)
            BookingStore.select_prestations(this.selected_prestations,location,agenda);
            this.$emit('submit',this.selected_prestations)
        }
      }
    },

    beforeMount(){
      this.setPrestasWithoutCategory();
    },

    mounted() {
      if (this.store.selected_prestations) {
        this.selected_prestations = this.store.selected_prestations;
      }

      if (this.store.selected_location_id) {
        this.location_id = this.store.selected_location_id;
      } else if (this.locations.length > 0) {
        this.location_id = this.locations[0].location_id;
      }

      if (this.store.selected_agenda_id) {
        this.agenda_id = this.store.selected_agenda_id;
      } else if (this.agendas.length > 0 && this.location_id) {
        this.agenda_id = this.agendas.find(a => a.location_id === this.location_id)?.agenda_id ?? null;
      }
      if (this.store.selected_category) {
        this.category_id = this.store.selected_category;
      }
      console.log("Mounting with defaults:");
      console.log("Agenda:", this.agenda_id);
      console.log("Location:", this.location_id);
      console.log("Category:", this.category_id);
      this.setBodyStyle();
      if(this.fo_config){
          this.fo_config["filter"].sort((prev, next) => prev.position - next.position);
      }
      console.log(this.store);
      this.setCategories();
      this.parseUrl();
      this.setPrestations();
      // this.filtered_agendas();
      // this.filtered_categories();
      // this.filtered_prestations();
      if (this.locations.length > 0) this.location_id = this.locations[0].location_id;
      // console.log('test');
      
      // Initiales agendas et location
      // console.log('agenda et loc',this.agendas.find(agenda => agenda.agenda_id == value),this.locations.find(location => location.location_id == value));
      
      // this.$emit('agendaChanged',this.agendas.find(agenda => agenda.agenda_id == value));
      // this.$emit('located',this.locations.find(location => location.location_id == value));
    },
}
</script>

<style>
#nextBtn:disabled{
  cursor: not-allowed;
  background-color: #80808096;
  border: none;
}
</style>
